import { render, staticRenderFns } from "./InboxProperty.vue?vue&type=template&id=13a8a48e&scoped=true&"
import script from "./InboxProperty.vue?vue&type=script&lang=js&"
export * from "./InboxProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a8a48e",
  null
  
)

export default component.exports